import React from "react";
import Weight from "./Weight";
import Height from "./Height";
import Scale from "./Scale";

export default function Imc() {
    const [weight, setWeight] = React.useState(undefined)
    const [height, setHeight] = React.useState(undefined)
    const [imc, setImc] = React.useState(undefined)

    React.useEffect(() => {
        if (weight && height) {
            let imc = weight / ((height / 100) * (height / 100))
            setImc(imc)
        } else {
            setImc(undefined)
        }
    }, [weight, height]);

    return (
        <>
            <div className="p-4 my-2 sm:my-4 bg-stone-100 rounded-lg">
                <div className="mb-6">
                    <Weight onChange={(newWeight) => setWeight(newWeight)} />
                </div>
                <Height onChange={(newHeight) => setHeight(newHeight)} />
            </div>

            <div className="mb-2 font-bold text-center w-full sm:text-lg cursor-default">
                Résultats
            </div>

            <div className="p-4 my-2 sm:my-4 bg-slate-200 rounded-lg w-full ">
                <div className="font-semibold mb-8">Votre imc est de <span className="font-bold text-lg sm:text-2xl">{imc ? imc.toFixed(1) : "--"}</span> kg/m<sup>2</sup></div>
                <Scale imc={imc} />
            </div>
        </>
    );
}